import { createSlice } from "@reduxjs/toolkit";


const snpNameSlice = createSlice({
    name :"snpname",
    initialState: {
        name : "",
    },
    reducers:{
        changename(state,action){
            state.name = action.payload
        }

    }
}) 

export const snpNameActions = snpNameSlice.actions;

export default snpNameSlice